import React from "react";
import InteractiveEditorInterface from "./InteractiveEditorInterface";
import { Interactive, deepMap, hydrate } from "./DataStructures";
import ErrorBoundary from "./ErrorBoundary";
import { alphaNumericSort } from '@bittnerdevelopmentgroup/interactive';
import './NetlifyWidget.scss';
import InteractiveRenderer from "./InteractiveRenderer";
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import FormControl from 'react-bootstrap/FormControl';
import Dropdown from 'react-bootstrap/Dropdown';
import Modal from "react-bootstrap/Modal";
import yaml from "js-yaml";
import TSV from 'tsv';
import { GoogleSpreadsheet } from 'google-spreadsheet';
import Spinner from "react-bootstrap/Spinner";

//CMS.init();
const DEBUG = false;
export function Preview({
  entry,
  value,
  onChange
}) {
  var _value;
  DEBUG && console.log("Preview entry", entry);
  if (value === undefined) {
    DEBUG && console.log("Preview value undefined");
    value = entry.getIn(["data", "interactive"]);
    DEBUG && console.log("Preview value", value);
  }
  DEBUG && console.log("Preview ToJS", value.toJS);
  let vJS = (_value = value) !== null && _value !== void 0 && _value.toJS ? value.toJS() : value;
  DEBUG && console.log("Preview vJS", vJS);
  if (vJS) {
    let i = new Interactive({
      ...vJS,
      panels: deepMap(vJS.panels, hydrate)
    });
    return /*#__PURE__*/React.createElement(InteractiveRenderer, {
      fullWidth: true,
      data: i
    });
  } else {
    return /*#__PURE__*/React.createElement("div", null, "Preview Failed to Load");
  }
}
function Widget({
  data,
  setData,
  onChange
}) {
  DEBUG && console.log("Widget render");
  return /*#__PURE__*/React.createElement(InteractiveEditorInterface, {
    noTitle: true,
    data: data,
    interactiveId: data.interactiveId,
    productId: data.productId,
    isSaving: false,
    onChanged: e => {
      DEBUG && console.log("Interactive onChanged", e);
      DEBUG && console.log("call this function?", onChange);
      let changed = {
        ...data,
        panels: deepMap(data.panels, item => {
          if (item.toJSON) {
            return item.toJSON();
          }
          return item;
        })
      };
      DEBUG && console.log("NetlifyWidget onChange");
      onChange(changed);
    }
  });
}
const NetlifyWidget = /*#__PURE__*/React.forwardRef(function ({
  entry,
  value,
  onChange,
  ...props
}) {
  DEBUG && console.log("entry", entry);
  DEBUG && console.log("raw", entry.getIn(["raw"]));
  if (value === undefined) {
    console.log("value undefined");
    value = {};
  }
  DEBUG && console.log("ToJS", value.toJS);
  let vJS = value.toJS ? value.toJS() : value;
  DEBUG && console.log("vJS", vJS);
  let i = new Interactive({
    ...vJS,
    panels: deepMap(vJS.panels, hydrate)
  });
  const [data, setData] = React.useState(i);
  DEBUG && console.log("Entry", entry, "value", vJS, "onChange", onChange, "props", props);
  DEBUG && console.log("data", data);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Widget, {
    data: data,
    setData: setData,
    onChange: onChange
  }));
});
export default NetlifyWidget;
const SlugWidget = /*#__PURE__*/React.forwardRef(function ({
  entry,
  value,
  onChange,
  ...props
}) {
  if (window.location.href.endsWith("manifests/new")) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", {
      type: "text",
      onChange: e => {
        console.log(e.target.value);
      }
    }));
  }
  return /*#__PURE__*/React.createElement("div", null, value, ": ", /*#__PURE__*/React.createElement("a", {
    href: `/#/collections/interactives/entries/${value}`,
    onClick: e => {
      e.preventDefault();
      window.location.href = e.target.href;
      window.location.reload();
    }
  }, "Edit Interactive"));
});
function ManifestEntry({
  v,
  old,
  className
}) {
  return /*#__PURE__*/React.createElement("details", {
    key: v.id,
    className: className
  }, /*#__PURE__*/React.createElement("summary", {
    className: "manifest-widget-summary unselectable-text"
  }, v.id, ": ", v.url, " ", className !== null && className !== void 0 && className.includes("duplicate") ? "DUPLICATE ID" : ""), /*#__PURE__*/React.createElement("dl", null, Object.keys(v).map(key => {
    if (old && old[key] !== v[key]) {
      if (v[key].constructor === Array) {
        let arr = [];
        for (let i = 0; i < Math.max(v[key].length, old[key].length); ++i) {
          if (v[key][i] !== undefined && old[key][i] !== undefined) {
            if (v[key][i] !== old[key][i]) {
              arr.push( /*#__PURE__*/React.createElement(React.Fragment, {
                key: `${key}.${i}`
              }, /*#__PURE__*/React.createElement("dt", null, `${key}.${i}`), /*#__PURE__*/React.createElement("dd", {
                className: "oldkey"
              }, old[key][i]), /*#__PURE__*/React.createElement("dd", {
                className: "newkey"
              }, v[key][i])));
            } else {
              arr.push( /*#__PURE__*/React.createElement(React.Fragment, {
                key: `${key}.${i}`
              }, /*#__PURE__*/React.createElement("dt", null, `${key}.${i}`), /*#__PURE__*/React.createElement("dd", null, v[key][i])));
            }
          } else if (v[key][i] !== undefined) {
            arr.push( /*#__PURE__*/React.createElement(React.Fragment, {
              key: `${key}.${i}`
            }, /*#__PURE__*/React.createElement("dt", null, `${key}.${i}`), /*#__PURE__*/React.createElement("dd", {
              className: "newkey"
            }, v[key][i])));
          } else if (old[key][i] !== undefined) {
            arr.push( /*#__PURE__*/React.createElement(React.Fragment, {
              key: `${key}.${i}`
            }, /*#__PURE__*/React.createElement("dt", null, `${key}.${i}`), /*#__PURE__*/React.createElement("dd", {
              className: "oldkey"
            }, old[key][i])));
          }
        }
        return arr;
      }
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: key
      }, /*#__PURE__*/React.createElement("dt", null, key), /*#__PURE__*/React.createElement("dd", {
        className: "oldkey"
      }, old[key]), /*#__PURE__*/React.createElement("dd", {
        className: "newkey"
      }, v[key]));
    }
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: key
    }, /*#__PURE__*/React.createElement("dt", null, key), /*#__PURE__*/React.createElement("dd", null, v[key]));
  })));
}
const SplitCard = ({
  manifestsBySplit,
  searched,
  searchBy,
  split
}) => {
  let filterResults = searchBy !== "" && searched !== "";
  let manifestsAdded = 0;
  let manifestsRemoved = 0;
  let manifestsChanged = 0;
  let items = [];
  Object.keys(manifestsBySplit[split]).map(k => {
    let manifest = manifestsBySplit[split];
    if (manifest[k].new && manifest[k].old) {
      let changed = false;
      for (const key of Object.keys(manifest[k].new)) {
        if (manifest[k].new[key] !== manifest[k].old[key]) {
          if (manifest[k].new[key] !== undefined && manifest[k].old[key] !== undefined && manifest[k].new[key].constructor === Array) {
            if (manifest[k].new[key].length !== manifest[k].old[key].length) {
              changed = true;
              break;
            }
            for (let i = 0; i < manifest[k].new[key].length; ++i) {
              if (manifest[k].new[key][i] !== manifest[k].old[key][i]) {
                changed = true;
                break;
              }
            }
          } else {
            changed = true;
            break;
          }
        }
      }
      if (!changed) {
        for (const key of Object.keys(manifest[k].old)) {
          if (manifest[k].new[key] === undefined && manifest[k].old[key] !== undefined) {
            changed = true;
            break;
          }
        }
      }
      if (!filterResults || manifest[k].new[searchBy].includes(searched)) {
        items.push( /*#__PURE__*/React.createElement(ManifestEntry, {
          v: manifest[k].new,
          old: manifest[k].old,
          className: changed ? "changed" : "unchanged"
        }));
        if (changed) {
          manifestsChanged += 1;
        }
      }
    } else if (manifest[k].new) {
      if (!filterResults || manifest[k].new[searchBy].includes(searched)) {
        manifestsAdded = manifestsAdded + 1;
        items.push( /*#__PURE__*/React.createElement(ManifestEntry, {
          v: manifest[k].new,
          className: "new"
        }));
      }
    }
    if (manifest[k].newduplicates) {
      for (const dupe of manifest[k].newduplicates) {
        if (!filterResults || dupe[searchBy].includes(searched)) {
          items.push( /*#__PURE__*/React.createElement(ManifestEntry, {
            v: dupe,
            className: "newduplicate"
          }));
        }
      }
    }
    if (manifest[k].old && !manifest[k].new) {
      if (!filterResults || manifest[k].old[searchBy].includes(searched)) {
        items.push( /*#__PURE__*/React.createElement(ManifestEntry, {
          v: manifest[k].old,
          className: "old"
        }));
        manifestsRemoved = manifestsRemoved + 1;
      }
    }
    if (manifest[k].oldduplicates) {
      for (const dupe of manifest[k].oldduplicates) {
        if (!filterResults || dupe[searchBy].includes(searched)) {
          items.push( /*#__PURE__*/React.createElement(ManifestEntry, {
            v: dupe,
            className: "oldduplicate"
          }));
        }
      }
    }
    return items;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
    key: split
  }, /*#__PURE__*/React.createElement(Accordion.Toggle, {
    as: Card.Header,
    eventKey: split
  }, split, ` (${items.length})`, /*#__PURE__*/React.createElement("span", {
    style: {
      margin: "0px .5rem 0px 1.5rem"
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "bi bi-plus-square",
    style: {
      color: "green",
      marginRight: ".25rem"
    }
  }), manifestsAdded), /*#__PURE__*/React.createElement("span", {
    style: {
      margin: "0px .5rem 0px .5rem"
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "bi bi-dash-square",
    style: {
      color: "red",
      marginRight: ".25rem"
    }
  }), manifestsRemoved), /*#__PURE__*/React.createElement("span", {
    style: {
      margin: "0px 1.5rem 0px .5rem"
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "bi bi-plus-slash-minus",
    style: {
      color: "#FFBE0A",
      marginRight: ".25rem"
    }
  }), manifestsChanged)), /*#__PURE__*/React.createElement(Accordion.Collapse, {
    eventKey: split
  }, /*#__PURE__*/React.createElement(Card.Body, null, items))));
};
const importInteractiveData = r => {
  let interactives = new Map();
  let data = r.keys().map(r);
  r.keys().map((filename, i) => {
    interactives[process.env.REACT_APP_INTERACTIVE_ID_PREFIX + `${filename.replace(/\.(yml)$/, "").replace(/\.\//, "")}`] = data[i].default;
  });
  return interactives;
};
const ManifestsWidget = /*#__PURE__*/React.forwardRef(function ({
  entry,
  value,
  onChange,
  ...props
}) {
  const [searched, setSearched] = React.useState("");
  const [searchBy, setSearchBy] = React.useState("id");
  const [interactivesToTrack, setInteractivesToTrack] = React.useState([]);
  const [untrackedInteractives, setUntrackedInteractives] = React.useState(undefined);
  const [showModal, setShowModal] = React.useState(false);
  const handleClose = () => setShowModal(false);
  const [yamlData, setYamlData] = React.useState(yaml.load(entry.toJS().raw));
  const [reloadYaml, setReloadYaml] = React.useState(false);
  const CLIENT_EMAIL = process.env.REACT_APP_MANIFEST_CLIENT_EMAIL;
  const PRIVATE_KEY = process.env.REACT_APP_MANIFEST_PRIVATE_KEY.replace(/\n/g, '\n');
  React.useEffect(() => {
    setYamlData(yaml.load(entry.toJS().raw));
  }, [reloadYaml]);
  React.useEffect(() => {
    const interactives = importInteractiveData(require.context(process.env.REACT_APP_MANIFEST_FOLDER, false, /\.(yml)$/));
    fetchManifestData().then(res => {
      if (!res) {
        return;
      }
      const manifestIds = res.filter(v => {
        return v.id !== "";
      }).map(v => {
        return v.id;
      });
      const missingInteractives = {};
      let interactiveKeys = Object.keys(interactives);
      let cloudfrontLink = yamlData.cloudfront_link;
      for (const i in interactiveKeys) {
        const baseId = interactiveKeys[i];
        let checkBaseId = true;
        for (const j in (_interactives$baseId = interactives[baseId]) === null || _interactives$baseId === void 0 ? void 0 : (_interactives$baseId$ = _interactives$baseId.interactive) === null || _interactives$baseId$ === void 0 ? void 0 : _interactives$baseId$.interactiveIds) {
          var _interactives$baseId, _interactives$baseId$;
          checkBaseId = false;
          const subId = interactives[baseId].interactive.interactiveIds[j];
          if (manifestIds.indexOf(subId) === -1) {
            var _interactives$baseId$2, _interactives$baseId2, _interactives$baseId3;
            missingInteractives[subId] = {
              id: subId,
              title: interactives[baseId].title,
              numberOfPanels: (_interactives$baseId$2 = (_interactives$baseId2 = interactives[baseId]) === null || _interactives$baseId2 === void 0 ? void 0 : (_interactives$baseId3 = _interactives$baseId2.interactive) === null || _interactives$baseId3 === void 0 ? void 0 : _interactives$baseId3.panels) !== null && _interactives$baseId$2 !== void 0 ? _interactives$baseId$2 : 0,
              url: cloudfrontLink + "/index.html#/" + baseId,
              manifestUrl: cloudfrontLink + "/interactives/" + subId + ".manifest.json"
            };
          }
        }
        if (checkBaseId && manifestIds.indexOf(baseId) === -1) {
          var _interactives$baseId$3, _interactives$baseId4, _interactives$baseId5;
          missingInteractives[baseId] = {
            id: baseId,
            title: interactives[baseId].title,
            numberOfPanels: (_interactives$baseId$3 = (_interactives$baseId4 = interactives[baseId]) === null || _interactives$baseId4 === void 0 ? void 0 : (_interactives$baseId5 = _interactives$baseId4.interactive) === null || _interactives$baseId5 === void 0 ? void 0 : _interactives$baseId5.panels) !== null && _interactives$baseId$3 !== void 0 ? _interactives$baseId$3 : 0,
            url: cloudfrontLink + "/index.html#/" + baseId,
            manifestUrl: cloudfrontLink + "/interactives/" + baseId + ".manifest.json"
          };
        }
      }
      setUntrackedInteractives(missingInteractives);
    });
  }, [untrackedInteractives]);
  let parsed = [];
  let oldparsed = [];
  if (value) {
    parsed = yaml.load(value).manifests;
  }
  if (entry) {
    oldparsed = yaml.load(yaml.load(entry.toJS().raw).interactives).manifests;
  }
  let keys = {};
  for (const v of parsed) {
    v.steps = undefined;
    if (!v.id || v.id === 'Unique id for interactive') continue;
    if (keys[v.id] === undefined) {
      keys[v.id] = {
        new: v
      };
    } else if (keys[v.id].new) {
      if (keys[v.id].newduplicates) {
        keys[v.id].newduplicates.push(v);
      } else {
        keys[v.id].newduplicates = [v];
      }
    } else {
      // this should never run
      keys[v.id].new = v;
    }
  }
  for (const v of oldparsed) {
    v.steps = undefined;
    if (!v.id || v.id === 'Unique id for interactive') continue;
    if (keys[v.id] === undefined) {
      keys[v.id] = {
        old: v
      };
    } else if (keys[v.id].old) {
      if (keys[v.id].oldduplicates) {
        keys[v.id].oldduplicates.push(v);
      } else {
        keys[v.id].oldduplicates = [v];
      }
    } else {
      keys[v.id].old = v;
    }
  }
  let sortedkeys = Object.keys(keys).sort(alphaNumericSort);
  let manifestsBySplit = {};
  let manifestItemKeys = [];
  for (let i = 0; i < sortedkeys.length; i++) {
    let splitOfOld = keys[sortedkeys[i]].old ? keys[sortedkeys[i]].old["splitEbook"] : undefined;
    let splitOfNew = keys[sortedkeys[i]].new ? keys[sortedkeys[i]].new["splitEbook"] : undefined;
    let split = splitOfOld || splitOfNew || "No Split";
    if (keys[sortedkeys[i]].old) {
      Object.keys(keys[sortedkeys[i]].old).forEach(v => {
        if (!manifestItemKeys.includes(v)) {
          manifestItemKeys.push(v);
        }
      });
    }
    if (keys[sortedkeys[i]].new) {
      Object.keys(keys[sortedkeys[i]].new).forEach(v => {
        if (!manifestItemKeys.includes(v)) {
          manifestItemKeys.push(v);
        }
      });
    }
    if (manifestsBySplit[split] === undefined) {
      manifestsBySplit[split] = {};
    }
    manifestsBySplit[split][sortedkeys[i]] = keys[sortedkeys[i]];
  }
  const fetchManifestData = async () => {
    let manifestLink = yamlData.manifest_link;
    let spreadsheetID = manifestLink.substring(manifestLink.indexOf("/d/") + "/d/".length, manifestLink.indexOf("/edit#"));
    let sheetID = manifestLink.substring(manifestLink.indexOf("#gid=") + "#gid=".length, manifestLink.length);
    const doc = new GoogleSpreadsheet(spreadsheetID);
    try {
      await doc.useServiceAccountAuth({
        private_key: PRIVATE_KEY,
        client_email: CLIENT_EMAIL
      });
      await doc.loadInfo();
      let text = await doc.sheetsById[sheetID].downloadAsTSV(true);
      let startingIndex = TSV.parse(text).map(function (e) {
        return e.id;
      }).indexOf('Unique id for interactive');
      let manifestData = TSV.parse(text).slice(startingIndex + 1);
      let manifestObjects = [];
      for (const manifest of manifestData) {
        if (!manifest.id) {
          continue;
        }
        if (!manifest.url) {
          continue;
        }
        let {
          id,
          title,
          url,
          description,
          sound,
          flashing,
          motionSimulation,
          numberOfPanels,
          manifestUrl,
          splitEbook,
          ...rest
        } = manifest;
        let objectives = Object.keys(rest).filter(k => k.startsWith("objectives")).map(k => manifest[k]).filter(v => v);
        let accessibilityHazard = [];
        if (sound) accessibilityHazard.push('sound');
        if (flashing) accessibilityHazard.push('flashing');
        if (motionSimulation) accessibilityHazard.push('motionSimulation');
        let newManifest = {
          id: id.trim(),
          title: title.trim(),
          url: url.trim(),
          version: "0.0.1",
          description,
          objectives,
          accessibilityHazard: accessibilityHazard.join(','),
          steps: new Array(Number(numberOfPanels)).fill({
            holdsNextStep: true
          }),
          splitEbook
        };
        manifestObjects.push(newManifest);
      }
      onChange(yaml.dump({
        manifests: manifestObjects
      }, {
        noRefs: true
      }));
      setReloadYaml(!reloadYaml);
      return manifestData;
    } catch (e) {
      console.error('Error: ', e);
    }
  };
  const addRowsToSpreadsheet = async (rows, manifestLink) => {
    let spreadsheetID = manifestLink.substring(manifestLink.indexOf("/d/") + "/d/".length, manifestLink.indexOf("/edit#"));
    let sheetID = manifestLink.substring(manifestLink.indexOf("#gid=") + "#gid=".length, manifestLink.length);
    const doc = new GoogleSpreadsheet(spreadsheetID);
    try {
      await doc.useServiceAccountAuth({
        private_key: PRIVATE_KEY,
        client_email: CLIENT_EMAIL
      });
      await doc.loadInfo();
      const sheet = doc.sheetsById[sheetID];
      for (let i = 0; i < rows.length; i++) {
        const result = await sheet.addRow(rows[i]);
      }
    } catch (e) {
      console.error('Error: ', e);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "manifest-widget"
  }, /*#__PURE__*/React.createElement("button", {
    style: {
      height: "35px",
      border: "soild 2px grey",
      borderRadius: "4px",
      marginBottom: "1rem"
    },
    onClick: async () => {
      await fetchManifestData();
      setUntrackedInteractives(undefined);
    }
  }, "Fetch Manifest Data"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "tracking-interactives"
  }, /*#__PURE__*/React.createElement("h3", null, "Tracked Interactives"), /*#__PURE__*/React.createElement("div", {
    style: {
      margin: "1rem 0px"
    }
  }, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Filter By:")), /*#__PURE__*/React.createElement(Dropdown, {
    style: {
      display: "inline",
      margin: "0px 4px 0px .5rem"
    }
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    id: "dropdown-basic"
  }, searchBy === "" ? "None" : searchBy), /*#__PURE__*/React.createElement(Dropdown.Menu, null, manifestItemKeys.map(v => {
    return /*#__PURE__*/React.createElement(Dropdown.Item, {
      onClick: e => {
        setSearchBy(v);
      }
    }, v);
  }))), /*#__PURE__*/React.createElement(Form, {
    style: {
      display: "inline-block",
      maxWidth: "25%",
      verticalAlign: "middle"
    }
  }, /*#__PURE__*/React.createElement(FormControl, {
    type: "search",
    placeholder: "Search",
    "aria-label": "Search",
    onChange: e => {
      setSearched(e.target.value);
    }
  }))), /*#__PURE__*/React.createElement(Accordion, null, Object.keys(manifestsBySplit).map(split => {
    return /*#__PURE__*/React.createElement(SplitCard, {
      manifestsBySplit: manifestsBySplit,
      searched: searched,
      searchBy: searchBy,
      split: split
    });
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "1rem"
    }
  }, /*#__PURE__*/React.createElement("h3", null, "Untracked Interactives"), untrackedInteractives === undefined && /*#__PURE__*/React.createElement(Spinner, {
    animation: "border"
  }), untrackedInteractives && Object.keys(untrackedInteractives).length === 0 && /*#__PURE__*/React.createElement("div", null, "All Interactives Are Tracked"), untrackedInteractives && /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexFlow: "column wrap",
      maxWidth: "65%",
      maxHeight: "350px"
    }
  }, Object.keys(untrackedInteractives).map((v, i) => {
    return /*#__PURE__*/React.createElement(Form, {
      style: {
        marginBottom: "5px"
      }
    }, /*#__PURE__*/React.createElement(Form.Check, {
      type: "checkbox"
    }, /*#__PURE__*/React.createElement(Form.Check.Input, {
      style: {
        width: "16px",
        height: "16px"
      },
      type: "checkbox",
      onClick: e => {
        let interactiveIndex = interactivesToTrack.indexOf(v);
        let trackingCopy = interactivesToTrack.slice();
        if (interactiveIndex === -1) {
          trackingCopy.push(v);
        } else {
          trackingCopy.splice(interactiveIndex, 1);
        }
        setInteractivesToTrack(trackingCopy);
      }
    }), /*#__PURE__*/React.createElement(Form.Check.Label, {
      style: {
        fontSize: "18px"
      }
    }, v)));
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: ".5rem"
    }
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: interactivesToTrack.length === 0,
    onClick: () => {
      setShowModal(true);
    }
  }, "Track Selected Interactives"))))), /*#__PURE__*/React.createElement(Modal, {
    show: showModal
  }, /*#__PURE__*/React.createElement(Modal.Header, null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "24px",
      color: "black",
      fontWeight: "500"
    }
  }, "Warning")), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("div", {
    style: {
      color: "black"
    }
  }, "This action will add the following interactives as manifest entries to the google sheet:", /*#__PURE__*/React.createElement("ul", {
    style: {
      paddingLeft: "2rem",
      marginTop: ".25rem"
    }
  }, interactivesToTrack.map(v => {
    return /*#__PURE__*/React.createElement("li", null, v);
  })))), /*#__PURE__*/React.createElement(Modal.Footer, {
    style: {
      display: "unset"
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "danger",
    style: {
      float: "left"
    },
    onClick: handleClose
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    style: {
      float: "right"
    },
    onClick: async () => {
      let newManifests = [];
      let manifestLink = yamlData.manifest_link;
      for (let i = 0; i < interactivesToTrack.length; i++) {
        newManifests.push(untrackedInteractives[interactivesToTrack[i]]);
      }
      addRowsToSpreadsheet(newManifests, manifestLink);
      await fetchManifestData();
      setUntrackedInteractives(undefined);
      handleClose();
    }
  }, "Confirm"))));
});
export function initNetlify(CMS) {
  let links = document.querySelectorAll("head link[rel='stylesheet']");
  let styles = document.querySelectorAll("head style");
  console.log("IB Netlify links, styles", links, styles);
  for (const link of links) {
    CMS.registerPreviewStyle(link.href);
  }
  for (const style of styles) {
    CMS.registerPreviewStyle(style.textContent, {
      raw: true
    });
  }
  CMS.registerWidget("ib", NetlifyWidget);
  CMS.registerWidget("manifest-slug", SlugWidget);
  CMS.registerWidget("manifests", ManifestsWidget);
  CMS.registerPreviewTemplate("interactives", Preview);
  CMS.init();
}

//CMS.registerWidget("ib", Template2)